// extracted by mini-css-extract-plugin
module.exports = {"text-area":"CaptionEditModal--text-area--3Sf8H","textArea":"CaptionEditModal--text-area--3Sf8H"};